<template>
  <div class="guests_item">
    <div class="headImg">
      <!-- <img class="headImgMax" @mouseout.stop="hiad" @mouseover.stop="ces($event)"  style="width: 100%;height: 100%" :src="guestsItem.avatarUrl" alt=""> -->
      <img class="headImgMax" style="width: 100%;height: 100%" :src="guestsItem.avatarUrl" alt="">
    </div>
    <div :class="$store.state.locale=='en'?'guestName enName':'guestName'">
      <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" :title="guestsItem.name">
        {{guestsItem.name}}
      </div>
    </div>
    <div class="guest_position" :title="guestsItem.position">
      {{guestsItem.position}}
    </div>

    <div v-show="show" :class="widen?'show_describe show_describe_widen':'show_describe'" :style="describeStyle" ref="describe">
      <div class="describe_title">
        <span style="font-size: 18px;font-weight: bold">{{guestsItem.name}}</span>
        <span style="font-size: 14px;">{{guestsItem.position}}</span>
      </div>
      <div class="describe_content">
        {{guestsItem.synopsis}}
      </div>
    </div>
    <div v-show="show" class="arrows" :style="arrowsStyle"></div>

  </div>
</template>

<script>
var _ = require('lodash');
export default {
  name: "AgendaHead",
  props:{
    guestsItem:{
      type:Object,
      default:()=>{}
    },
    widen:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      show:false,
      describeStyle:'',
      arrowsStyle:'',
      describeTitle:'',
      time:null
    }
  },
  methods:{
    ces(e){
      clearTimeout(this.time)
      this.time = setTimeout(()=>{
        this.getShowDescribe(e)
      },300)
    },
    hiad(){
      this.show = false
      clearTimeout(this.time)
    },
    // ces:_.debounce(function (e){
    //   this.getShowDescribe(e)
    // },300,{
    //     'leading': true,
    //     'trailing': false
    //   })
    // ,
    getShowDescribe(e){
      let top = e.target.getBoundingClientRect().top
      let arrowLeft = e.target.getBoundingClientRect().left
      let nameWidth = document.getElementsByClassName('guestName')[0].clientWidth
      let left = document.getElementsByClassName('guests_item')[0].getBoundingClientRect().left
      this.describeStyle = `top:${top+203}px;left:${left}px`
      this.arrowsStyle = `top:${top+198}px;left:${arrowLeft+61}px;`
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.arrows{
  position: fixed;
  width: 15px;
  height: 15px;
  background: #0331A6;
  transform: rotate(45deg);
  border-radius: 2px;
}
.show_describe{
  position: fixed;
  z-index: 999;
  height: 220px;
  width: 950px;
  background: linear-gradient(0deg, #002480 0%, #0331A6 99%);
  Box-shadow: inset 11px 0px 20px -15px #fff, inset -15px 0px 20px -20px #fff;
  border-radius: 4px;
  padding: 20px 20px;
  .describe_title{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #fff;
    border-bottom: 1px solid #B1C7FF;
    padding-bottom: 5px;
  }
  .describe_content{
    height: 155px;
    color: #fff;
    font-size: 14px;
    padding-top: 10px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:7;
    -webkit-box-orient:vertical;
  }
}
.show_describe_widen{
  width: 1200px !important;
}

.guests_item{
  width: 144px;
.headImg{
  width: 120px;
  height: 120px;
  margin: auto;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #0D51FF;
}
.guestName{
  position: relative;
  margin-top: 35px;
  color: #1A1D4A;
  font-size: 16px;
  font-weight: bold;
  font-family: Source Han Sans CN;
  text-align: center;


}

.enName{
  font-size: 16px;
}
.guest_position{
  height: 42px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
  color: #666666;
  font-size: 14px;
  text-align: center;
  margin-top: 15px;

}
  .headImgMax{
    transition: all 0.6s;
    -webkit-transition: all 0.6s; /* Safari */
  }
  .headImg:hover{
    box-shadow: 0px 6px 16px 0px rgba(0, 63, 124, 0.48);
  }
  .headImgMax:hover{
    transform: scale(1.2);
  }
}
</style>